import React from 'react';
import CRUDDetailPage from '../../../../shared/components/crud/CRUDDetailPage';
import { districtConfig } from '../config/districtConfig';
import { DistrictService } from '../../../../shared/services/districtService';

/**
 * DistrictDetail - URL-based detail page for Districts
 * Handles view, edit, and add modes with ID from URL params
 */
export default function DistrictDetail() {
  return (
    <CRUDDetailPage
      config={districtConfig}
      service={DistrictService}
    />
  );
}
